<template>
  <div>
    <div class="home">
      <div class="header-container">
        <div class="survey-logo" v-if="logo != null && logo != ''">
          <img v-bind:src="'data:image/png;base64,' + logo" />
        </div>
        <h1 class="h1-class">{{ surveyName }}</h1>
      </div>
      <div class="survey-section trivia-styles-finished">
        <div class="q-full-container">
          <h2
            style="    text-align: center;
      font-size: 20px;
      margin: 90px 0;"
          >
            <v-runtime-template :template="endMessage" style="display:inline-block"/>
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VRuntimeTemplate from "v-runtime-template";
import surveysService from "@/services/Surveys/surveys";
export default {
  name: "finished",
   components: {
    VRuntimeTemplate
  },
  data: function() {
    return {
      endMessage: "",
      logo: "",
      surveyName: "",
      css: "",
      resultId: "",
      customCSS: "",
    };
  },
  methods: {
    appendFile: function(css){
      let file = document.createElement("link");
      file.rel = "stylesheet";
      file.href = process.env.VUE_APP_BASE_CLIENT_URL + "/static/" + css;
      document.head.appendChild(file);
      //console.log("Entro a append file");
    },
    overrideStyles: function(customCSS) {
      let style = document.createElement("style");
      style.type = 'text/css';
      style.appendChild(document.createTextNode(customCSS));
      document.head.appendChild(style);
    },
    resetSurvey: function() {
      surveysService
        .restartSurvey(this.resultId)
        .then(response => {
          //console.log(response);
          this.$router.push({
            name: "surveys",
            query: { q: this.resultId }
          });
          return;
        })
        .catch(e => {
          console.log(e);
          this.$notifyError("Error obteniendo encuesta");
        });
    }
  },
  mounted: function() {
    this.endMessage = this.$route.params.end_message;
    if (this.endMessage.startsWith("<div>") === false) {
      this.endMessage = "<div>" + this.endMessage;
      this.endMessage = this.endMessage + "</div>";
    }
    this.logo = this.$route.params.logo;
    this.surveyName = this.$route.params.survey_name;
    this.css = this.$route.params.css;
    this.resultId = this.$route.params.resultId;
    this.customCSS = this.$route.params.customCSS;
  }
};
</script>
